module.exports = __webpack_public_path__ + "img/9000.4f6cc28b.jpg";